import { render, staticRenderFns } from "./annualBarChart.vue?vue&type=template&id=c8b10190&scoped=true"
import script from "./annualBarChart.vue?vue&type=script&lang=js"
export * from "./annualBarChart.vue?vue&type=script&lang=js"
import style0 from "./annualBarChart.vue?vue&type=style&index=0&id=c8b10190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b10190",
  null
  
)

export default component.exports